import Accordion from "./Accordion";
import BYOB, { initBYOB } from "./BYOB";
import { initSideCart } from "./SideCart";
import { initSpecModal } from "./SpecModal";
import { initQuickView } from './QuickViewBundle';
import { initFrequentlyBoughtTogether } from "./FrequentlyBoughtTogether";

// Conditional registration to prevent NotSupportedError
if (!customElements.get("accordion-list")) {
  customElements.define("accordion-list", Accordion);
}

// Initialize BYOB and SideCart when DOM is ready
document.addEventListener("DOMContentLoaded", async () => {
  const byob = initBYOB();

  await byob?.initBundleContents();
  // const contents = initBundleContents();

  initSideCart();
  initSpecModal();
  initQuickView();
  initFrequentlyBoughtTogether();
});
